/**
 * Feature split: tabbed collection titles + crossfading images + Shop now on active row.
 */
(function () {
  function initFeatureSplit(root) {
    var tabs = root.querySelectorAll('[data-feature-split-tab]');
    var panels = root.querySelectorAll('[data-feature-split-panel]');
    var shops = root.querySelectorAll('[data-feature-split-shop]');
    var rows = root.querySelectorAll('[data-feature-split-row]');
    var n = tabs.length;
    if (!n) return;

    var active = 0;

    function setActive(i) {
      if (i < 0 || i >= n) return;
      active = i;

      tabs.forEach(function (el, j) {
        var on = j === i;
        el.setAttribute('aria-selected', on ? 'true' : 'false');
        el.setAttribute('tabindex', on ? '0' : '-1');
      });

      panels.forEach(function (el, j) {
        var on = j === i;
        el.classList.toggle('opacity-100', on);
        el.classList.toggle('opacity-0', !on);
        el.classList.toggle('z-[1]', on);
        el.classList.toggle('z-0', !on);
        el.setAttribute('aria-hidden', on ? 'false' : 'true');
      });

      shops.forEach(function (el, j) {
        var on = j === i;
        el.classList.toggle('opacity-100', on);
        el.classList.toggle('opacity-0', !on);
        el.classList.toggle('translate-x-0', on);
        el.classList.toggle('translate-x-3', !on);
        el.classList.toggle('pointer-events-none', !on);
      });

      rows.forEach(function (el, j) {
        el.setAttribute('data-active', j === i ? 'true' : 'false');
      });
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-feature-split-tab]');
      if (!t || !root.contains(t)) return;
      var idx = parseInt(t.getAttribute('data-index'), 10);
      if (Number.isNaN(idx)) return;
      setActive(idx);
    });

    root.addEventListener('keydown', function (e) {
      var tab = e.target.closest('[data-feature-split-tab]');
      if (!tab || !root.contains(tab)) return;
      var next = active;
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
        next = Math.min(n - 1, active + 1);
      } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
        next = Math.max(0, active - 1);
      } else if (e.key === 'Home') {
        next = 0;
      } else if (e.key === 'End') {
        next = n - 1;
      } else {
        return;
      }
      e.preventDefault();
      setActive(next);
      tabs[next].focus();
    });

    setActive(0);
  }

  function boot() {
    document.querySelectorAll('[data-feature-split]').forEach(initFeatureSplit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var roots = e.target.querySelectorAll('[data-feature-split]');
    roots.forEach(initFeatureSplit);
  });
})();
